import { useMatch } from "react-router-dom"

export const useActiveKeyTabsUsers = () => {
  const activeKey = useMatch({ path: "/:page/:activeKey", end: false })?.params
    ?.activeKey

  return { activeKey }
}
